import { render, staticRenderFns } from "./RefundDetailComponent.vue?vue&type=template&id=5b1bc573&scoped=true"
import script from "./RefundDetailComponent.vue?vue&type=script&lang=js"
export * from "./RefundDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./RefundDetailComponent.vue?vue&type=style&index=0&id=5b1bc573&prod&scoped=true&lang=css"
import style1 from "./RefundDetailComponent.vue?vue&type=style&index=1&id=5b1bc573&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1bc573",
  null
  
)

export default component.exports